import { getMarketInfoCollection, thunkCall } from "tm-shared/api";

export const getMarketInfoCollectionUnplannedThunk = thunkCall(
    "getMarketInfoCollectionUnplannedThunk",
    getMarketInfoCollection,
);
